import { render, staticRenderFns } from "./ComparativeScoreCards.vue?vue&type=template&id=71092e5e&scoped=true&"
import script from "./ComparativeScoreCards.vue?vue&type=script&lang=js&"
export * from "./ComparativeScoreCards.vue?vue&type=script&lang=js&"
import style0 from "./ComparativeScoreCards.vue?vue&type=style&index=0&id=71092e5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71092e5e",
  null
  
)

export default component.exports